import React, { Component } from "react";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import PrivatePostKidsItem from "./PrivatePostKidsItem";
import Close from "../../../../Icons/Close";
export default class ModalPostPrivate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.closeModal = this.closeModal.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  closeModal = (event) => {
    event.preventDefault();
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.CloseModalPostPrivate();
    }, 400);
  };

  render() {
    return (
      <StyleRoot>
        <div
          className="modal show modal-skin  modal-childunit"
          role="dialog"
          aria-labelledby="modalPostPrivate"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={(e) => this.closeModal(e)}
                  />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title mt-0">
                      Enfants concernés par ce post
                    </h5>
                    {this.props.selectedPost.enfants.length > 0 ? (
                      <ul className="row mx-n2 list-enfants">
                        {this.props.selectedPost.enfants.map((element) => (
                          <PrivatePostKidsItem kid={element} />
                        ))}
                      </ul>
                    ) : (
                      ""
                    )}
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
